var $ = jQuery;
import {bodyNoScroll, decodeEntities} from '../utils/utilities.js';
/* eslint-disable */
import featherlight from '../libs/featherlight.js';
/* eslint-enable */


function loadYoutubeApi() {
  // Load the IFrame Player API code asynchronously.
  var tag = document.createElement('script');
  tag.id = 'youtubeScript';
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

function youtubeInit(vidID) {
  //create the #player div inside the lightbox
  if( !$('.video-overlay__featherlight #player').length ) {
    $('.video-overlay__featherlight .video-overlay-main__video-container').append('<div id="youtube-player"></div>');
  }

  //If the Youtube Iframe API hasn't been loaded
  if (!$('#youtubeScript').length) {
    loadYoutubeApi();
    // Create an <iframe> (and YouTube player) after the API code downloads.
    window.onYouTubeIframeAPIReady = function () {
      initPlayer();
    };
  }
  else {
    $('iframe#youtube-player').remove();
    initPlayer();
  }

  function initPlayer() {
    /* eslint-disable */
    window.player = new YT.Player('youtube-player', {
      videoId: vidID,
      height: '100%',
      width: '100%'
    });
    /* eslint-enable */
  }
}

function buildMainVideo(data) {
  //Build main video component
  $('.video-overlay-main__title').text(decodeEntities(data.videoTitle));
  $('.video-overlay-main__date').text(data.videoDate);
  $('.video-overlay-main__length').text(data.videoLength);
  $('.video-overlay-main__video-body').text(decodeEntities(data.videoBody));
}

function buildFeaturedVideos(datajson) {
  var total = datajson.length;
  $('.video-overlay-related__video-container:not(:first-child)').remove();

  $.each(datajson, function(index, value) {
    let counter =  index + 1;
    let container = $('.video-overlay-related__video-container:first-child');
    let thisJson = JSON.stringify(datajson[index]);

    container.find('.video-overlay-related__title').text(decodeEntities(this.videoTitle));
    container.find('.video-overlay-related__date').text(this.videoDate);
    container.find('.video-overlay-related__length').text(this.videoLength);
    container.find('.video-overlay-related__video-image').css({'background-image': 'url("' + this.videoScreenshot + '")'});
    container.attr('data-video-overlay', thisJson);

    if (counter < total) {
      $(container[0]).clone().prependTo('.video-overlay-related__videos-wrapper');
    }
    else {
      $('.video-overlay-related__video-container:last-child').addClass('video-overlay-related__playing').siblings().removeClass('video-overlay-related__playing');
    }
  });
}

function buildVideoOverlay(trigger) {
  //avoid bubbling errors by looking for the closest element with the trigger class
  var $actualTrigger = $(trigger).closest('.js-video-trigger');
  var datajson = $($actualTrigger).data('video-overlay');
  buildMainVideo(datajson[0]);
  buildFeaturedVideos(datajson);
}

function videoOverlayInit() {
  var overlayTrigger= $('.js-video-trigger');
  var overlayTarget = $('.js-video-target')[0];

  if(overlayTrigger.length) {
    loadYoutubeApi();
  }

  var changeMainVideo = function(clickEvent) {
    let thisData = $(clickEvent.target).closest('.video-overlay-related__video-container').data('video-overlay');
    buildMainVideo(thisData);
    //change the video in the player
    youtubeInit(thisData.youtubeID);



    //scroll to top
    $('.featherlight-content').animate({
      scrollTop: 0
    }, 200);
    //change of the __playing class
    $(clickEvent.target).closest('.video-overlay-related__video-container').addClass('video-overlay-related__playing').siblings().removeClass('video-overlay-related__playing');
  };

  function bindFeatherlightVideo() {
    if(overlayTrigger.length) {
      //for each trigger create an instance of featherlight
      overlayTrigger.each(function() {
        $(this).featherlight($(overlayTarget), {
          variant: 'video-overlay__featherlight',
          otherClose: '.event__close-modal',
          beforeOpen: function(event) {
            buildVideoOverlay(event.target);
          },
          afterOpen: function(event) {
            youtubeInit($(event.target).closest('.js-video-trigger').data('video-overlay')[0].youtubeID);
            //bind click to related events to changeVideoFunction
            $(document).on('click', '.video-overlay-related__video-container', changeMainVideo);
            $('.event__close-modal').focus();
            bodyNoScroll();
          },
          afterClose: function(event) {
            //unbind the clicks
            $(document).off('click', '.video-overlay-related__video-container', changeMainVideo);
            bodyNoScroll();
          }
        });
      });
    }
  }

  bindFeatherlightVideo();
  // $(document).on('ajaxreload', bindFeatherlightVideo());
  //$(document).trigger('ajaxreload');

  //bind featherlight video links everytime there's an AJAX call (as in a content list call)
  $( document ).ajaxComplete(function() {
    overlayTrigger= $('.js-video-trigger');
    bindFeatherlightVideo();
  });

}


export { videoOverlayInit };
